var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dyn-page", class: _vm.theme },
    [
      _vm.theme === "rose"
        ? _c(
            "div",
            { staticClass: "petals" },
            _vm._l(18, function (n) {
              return _c("span", { key: n, style: _vm.petalStyle(n) })
            }),
            0
          )
        : _vm._e(),
      _vm.loading
        ? _c("div", { staticClass: "dyn-state" }, [
            _c("div", { staticClass: "state-ico" }, [_vm._v("✉")]),
            _c("div", { staticClass: "state-text" }, [_vm._v("正在拆信…")]),
          ])
        : _vm.error
        ? _c("div", { staticClass: "dyn-state" }, [
            _c("div", { staticClass: "state-ico" }, [_vm._v("✉")]),
            _c("div", { staticClass: "state-text" }, [
              _vm._v(_vm._s(_vm.error)),
            ]),
            _c("div", { staticClass: "state-btn", on: { click: _vm.goList } }, [
              _vm._v("回到信箱"),
            ]),
          ])
        : [
            _c("div", { staticClass: "dyn-card" }, [
              _c("header", { staticClass: "dyn-head" }, [
                _c("div", { staticClass: "head-orn" }, [
                  _vm._v(_vm._s(_vm.theme === "rose" ? "❀" : "✿")),
                ]),
                _vm.page.nameText
                  ? _c("div", { staticClass: "dyn-name" }, [
                      _vm._v(_vm._s(_vm.page.nameText)),
                    ])
                  : _vm._e(),
                _c("h1", { staticClass: "dyn-title" }, [
                  _vm._v(_vm._s(_vm.page.title)),
                ]),
                _vm.page.subtitle
                  ? _c("div", { staticClass: "dyn-sub" }, [
                      _vm._v(_vm._s(_vm.page.subtitle)),
                    ])
                  : _vm._e(),
                _vm.page.date
                  ? _c("div", { staticClass: "dyn-date" }, [
                      _vm._v(_vm._s(_vm.page.date)),
                    ])
                  : _vm._e(),
              ]),
              _vm.verses.length
                ? _c(
                    "div",
                    { staticClass: "dyn-verses" },
                    [
                      _vm._l(_vm.verses, function (v, i) {
                        return _c(
                          "p",
                          { key: "v" + i, staticClass: "dyn-verse" },
                          [_vm._v(_vm._s(v))]
                        )
                      }),
                      _vm.page.verseFrom
                        ? _c("p", { staticClass: "dyn-from" }, [
                            _vm._v("—— " + _vm._s(_vm.page.verseFrom)),
                          ])
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "dyn-body" },
                _vm._l(_vm.paragraphs, function (p, i) {
                  return _c(
                    "p",
                    {
                      key: "p" + i,
                      staticClass: "dyn-p",
                      style: { animationDelay: 0.15 + i * 0.1 + "s" },
                    },
                    [_vm._v(_vm._s(p))]
                  )
                }),
                0
              ),
              _vm.page.sign || _vm.page.signDate
                ? _c("div", { staticClass: "dyn-divider" }, [
                    _c("span", [_vm._v("❦")]),
                  ])
                : _vm._e(),
              _c("footer", { staticClass: "dyn-sign" }, [
                _vm.page.sign
                  ? _c("span", { staticClass: "sign-name" }, [
                      _vm._v(_vm._s(_vm.page.sign)),
                    ])
                  : _vm._e(),
                _vm.page.signDate
                  ? _c("span", { staticClass: "sign-date" }, [
                      _vm._v("——" + _vm._s(_vm.page.signDate)),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _c("div", { staticClass: "dyn-back", on: { click: _vm.goList } }, [
              _c("span", { staticClass: "back-ico" }, [_vm._v("‹")]),
              _vm._v(" 返回信箱 "),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }